/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createActionsHook,
	createStateHook,
	type Action,
	type BoundActions,
	type HookActionsFunction,
	type HookStateFunction,
} from '@atlassian/react-sweet-state';
import type {
	BannerState,
	BottomRightPortalState,
	LayoutState,
	LeftSidebarState,
	PreviewPanelState,
	RightSidebarState,
} from '../../../../common/types.tsx';
import type { LayoutActions } from '../../actions/index.tsx';
import { layoutStore } from '../../store/index.tsx';

export const useBottomRightCornerContainer: HookStateFunction<HTMLElement | undefined, undefined> =
	createStateHook<LayoutState, LayoutActions, HTMLElement | undefined, undefined>(layoutStore, {
		selector: (state) => state.bottomRightCorner.container,
	});

export const useBottomRightCornerActions: HookActionsFunction<
	BoundActions<
		LayoutState,
		{
			readonly setIsChromeless: (isChromeless: boolean) => Action<LayoutState>;
			readonly setIsFullscreen: (isFullscreen: boolean) => Action<LayoutState>;
			readonly showBanner: (newState: BannerState) => Action<LayoutState>;
			readonly dismissCurrentBanner: () => Action<LayoutState>;
			readonly setLeftSidebarState: (newState: Partial<LeftSidebarState>) => Action<LayoutState>;
			readonly setRightSidebarState: (newState: RightSidebarState) => Action<LayoutState>;
			readonly openRightSidebar: (
				panelId: string,
				width: number,
				isMinimised?: boolean,
				toTop?: boolean,
			) => Action<LayoutState>;
			readonly closeRightSidebar: (panelId: string) => Action<LayoutState>;
			readonly closeAllRightSidebar: () => Action<LayoutState>;
			readonly closeCurrentRightSidebar: () => Action<LayoutState>;
			readonly minimiseRightSidebar: (panelId: string) => Action<LayoutState>;
			readonly registerBottomRightCornerContainer: (
				ref: HTMLElement | null | undefined,
			) => Action<LayoutState>;
			readonly insertBottomRightCornerPortal: (
				item: BottomRightPortalState,
			) => Action<LayoutState, void, number>;
			readonly removeBottomRightCornerPortal: (id: string) => Action<LayoutState>;
			readonly setPreviewPanelState: (newState: Partial<PreviewPanelState>) => Action<LayoutState>;
		}
	>
> = createActionsHook<LayoutState, LayoutActions>(layoutStore);
